<template>
  <Modal
    v-model="modalVisibile"
    width="1400"
    :mask-closable="false"
    :title="modalTitle"
    @on-cancel="handleCancel"
  >
    <div slot="header">
      <span class="modal_title">{{modalTitle}}</span>
      <span class="order_sum" v-if="sum_money && formData.refund_status!=1">总计: <b class="money">￥{{sum_money}}</b></span>
      <span class="order_sum" v-if="sum_money && formData.refund_status==0">手续费: <b class="money">￥{{((sum_money - refund_money)*6/1000).toFixed(2)}}</b></span>
      <span class="order_sum" v-if="refund_money">已退款: <b class="money">￥{{refund_money}}</b>(手续费由微信官方退回)</span>
      <span class="order_sum" v-if="sum_money && formData.refund_status==0">结余费: <b class="money">￥{{(sum_money - refund_money - ((sum_money - refund_money) * 6/1000).toFixed(2)).toFixed(2)}}</b></span>
    </div>
    <div class="clearfix">
      <Form @submit.native.prevent :model="formData" label-position="left" inline class="mytable-titleBox fl">
        <FormItem label="用户昵称:" :label-width="72">
          <Input v-model="formData.username" style="width: 140px"></Input>
        </FormItem>
        <FormItem label="文章标题:" :label-width="72">
          <Input v-model="formData.title" style="width: 140px"></Input>
        </FormItem>
        <FormItem label="购买人手机号:" :label-width="100">
          <Input v-model="formData.phone" style="width: 140px"></Input>
        </FormItem>
        <FormItem label="订单号:"  :label-width="64">
          <Input v-model="formData.order_no" style="width: 140px"></Input>
        </FormItem>
        <FormItem label="购买日期:" :label-width="72">
          <DatePicker v-model="formData.date" @on-change="formData.date=$event" style="width: 180px" type="daterange" format="yyyy-MM-dd" placeholder="开始日期 ~ 结束日期"></DatePicker>
        </FormItem>
      </Form>
      <div class="fr checkReset">
        <Button type="primary" class="fl" @click="handleQuery">查询</Button>
        <Button class="fl" @click="handleReset">重置</Button>
      </div>
      <div class="clearfix s-line"></div>
      <RadioGroup v-model.trim="formData.refund_status" type="button" class="fl mr20" @on-change="handleRefundChange">
        <Radio :label="0">全部</Radio>
        <Radio :label="1">已退款</Radio>
        <Radio :label="3">退款中</Radio>
        <Radio :label="4">退款异常</Radio>
      </RadioGroup>
    </div>
    <Table :loading="tableLoading" class="mt24" :columns="columns" :data="tableData"></Table>
    <div slot="footer">
      <Page class="mt24" :total="total" :current="page_num" show-elevator show-total @on-change="handlePageChange"/>
    </div>
    <refundModal ref="refundModal" :id="refundId" :param="activeParam" :type="0" modalTitle="是否确认退款该笔订单" @success="getTableData"></refundModal>
  </Modal>
</template>

<script>
import timeMixin from '@/mixins/time'
import mixin from '@/mixins/page'
import refundModal from '@/components/refundModal.vue'
export default {
  name: 'author_order',
  mixins: [mixin, timeMixin],
  components: {
    refundModal
  },
  props: {
    modalTitle: {
      default: '作者订单'
    },
    id: {
      default: ''
    }
  },
  data () {
    return {
      activeParam: {},
      refundId: '',
      formData: {
        date: '',
        refund_status: 0
      },
      sum_money: '',
      refund_money: '',
      formData1: {
        date: '',
        refund_status: 0
      },
      tableData: [],
      modalVisibile: false,
      columns: [
        {
          title: '商户订单号',
          key: 'order_no',
          width: 200
        },
        {
          title: '购买人昵称',
          key: 'username',
          width: 110,
          align: 'center'
        },
        {
          title: '手机号',
          key: 'phone',
          minWidth: 100,
          align: 'center'
        },
        {
          title: '价格',
          key: 'money',
          width: 60,
          align: 'center',
          render: (h, params) => {
            return params.row.status === 1
              ? h('span', {
                class: {
                  red: true
                }
              }, params.row.money)
              : null
          }
        },
        {
          title: '手续费',
          key: 'money',
          minWidth: 70,
          align: 'center',
          render: (h, params) => {
            return h('span', {
              class: {
                red: true
              }
            }, (params.row.money * 6 / 1000).toFixed(2))
          }
        },
        {
          title: '结余费',
          key: 'money',
          minWidth: 70,
          align: 'center',
          render: (h, params) => {
            return h('span', {
              class: {
                red: true
              }
            }, (params.row.money - (params.row.money * 6 / 1000).toFixed(2)).toFixed(2))
          }
        },
        {
          title: '作者昵称',
          key: 'post_username',
          width: 110,
          align: 'center'
        },
        {
          title: '文章标题',
          key: 'title',
          tooltip: true,
          minWidth: 120
        },
        {
          title: '来源',
          key: 'applet_type',
          width: 80,
          render: (h, params) => {
            if (params.row.applet_type === 1) {
              return h('span', {

              }, '内部分享')
            } else if (params.row.applet_type === 2) {
              return h('span', {

              }, '内部说')
            } else if (params.row.applet_type === 3) {
              return h('span', {

              }, '足球财富资讯')
            } else if (params.row.applet_type === 4) {
              return h('span', {
              }, '内部料')
            } else if (params.row.applet_type === 5) {
              return h('span', {
              }, 'H5网页')
            } else if (params.row.applet_type === 6) {
              return h('span', {
              }, 'H5网页')
            } else if (params.row.applet_type === 7) {
              return h('span', {
              }, '跃查看')
            } else if (params.row.applet_type === 8) {
              return h('span', {
              }, '欣跃读')
            }else if (params.row.applet_type === 9) {
              return h('span', {
              }, '人人查看')
            } else {
              return h('span', {
              }, '未知')
            }
          }

        },
        {
          title: '下单时间',
          key: 'create_time',
          width: 150
        },
        {
          title: '退款时间',
          key: 'refund_time',
          width: 150
        },
        {
          title: '退款操作',
          width: 100,
          key: 'post_username',
          render: (h, params) => {
            let returnHtml = ''
            switch (params.row.refund_status) {
              case 0:
                if (!this.isRefundExpire(params.row.create_time)) {
                  returnHtml = h('span', {
                    class: {
                      btn_refund: true
                    },
                    on: {
                      click: () => this.handleRefund(params)
                    }
                  }, '申请退款')
                }
                break
              case 1:
                returnHtml = h('span', { class: { gray: true } }, '退款成功')
                break
              case 3:
                returnHtml = h('span', { class: { yellow: true } }, '退款中')
                break
              case 4:
                returnHtml = h('span', { class: { red: true } }, '退款异常')
                break
            }
            return returnHtml
          }
        }
      ]
    }
  },
  mounted () {
    this.handleQuery()
  },
  methods: {
    handleRefundChange () {
      this.handleQuery()
    },
    handleQuery () {
      this.page_num = 1
      this.getTableData()
    },
    handleReset () {
      this.formData = Object.assign({}, this.formData1)
      this.handleQuery()
    },
    getTableData () {
      let start_time = this.formData.date[0] ? this.formData.date[0] + ' 00:00:00' : ''
      let end_time = this.formData.date[1] ? this.formData.date[1] + ' 24:00:00' : ''
      this.tableLoading = true
      let param = { ...this.formData, page_num: this.page_num, page_size: this.page_size, author_id: this.id, start_time, end_time }
      if (param.refund_status == 0) {
        delete param.refund_status
      }
      this.$api.getAuthorOrder(param).then(res => {
        if (res.code === 0) {
          this.tableData = res.data.list
          this.total = res.data.total_row
          this.sum_money = res.data.ext.sum_money
          this.refund_money = res.data.ext.refund_money
        } else {
          this.$Message.error(res.msg)
        }
        this.tableLoading = false
      })
    },
    // 查看文章
    viewArticle () {

    },
    handleCancel () {
      this.tableData = []
      this.formData = Object.assign({}, this.formData1)
    },
    // 退款
    handleRefund (param) {
      this.$refs.refundModal.modalVisibile = true
      this.refundId = param.row.id
      this.activeParam = param.row;
    }
  }
}
</script>

<style scoped lang="less">
/deep/ .ivu-modal-footer{
  padding-top: 0;
}
/deep/ .ivu-modal-body{
  padding-bottom: 0;
}
  .modal_title{
    font-weight: 900;
  }
  .order_sum{
    margin-left: 24px;
  }
.money{
  color:#ff5579;
  font-weight: 700;
}
  .s-line{
    border-bottom: 1px solid #E9E9E9;
    padding-bottom: 10px;
    margin-bottom: 10px;
  }
</style>
